import templateUrl from './dayPartsTableComponent.html';

export default {
  bindings: {
    dayParts: '<',
    onEdit: '&',
    onRemove: '&',
  },
  controllerAs: 'ctrl',
  templateUrl,
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "settings" */ './dayPartsTableComponentCtrl')).default,
};
